module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112921-DealerDraft-Infinity-1Lifestyle.d9a6929a.jpeg";